import { isNil } from 'lodash';
import { BusinessPotential } from '../../constants/acquisition';

class BusinessPotentialModel {
    constructor({ potential = null } = {}) {
        this.potential = potential;
    }

    get hasUnknownPotential() {
        return this.potential === BusinessPotential.Unknown;
    }

    get hasPotential() {
        return this.potential === BusinessPotential.Exists;
    }

    get hasNoPotential() {
        return this.potential === BusinessPotential.None || isNil(this.potential);
    }
}

export default BusinessPotentialModel;
